import { AnyAction } from 'redux';
import { MedicalCertificateDTO } from '../../models/dto/MedicalCertificateDTO';
import { authenticationActionTypes } from '../actions/authActions';
import { medicalCertificatesActionsTypes } from '../actions/medicalCertificatecActions';

export interface MedicalCertificatesReducerData {
  loadingMedicalCertificates: boolean;
  medicalCertificates: MedicalCertificateDTO[];
}

const INITIAL_STATE = {
  loadingMedicalCertificates: false,
  medicalCertificates: [],
};

export default (
  state: MedicalCertificatesReducerData = INITIAL_STATE,
  action: AnyAction,
): MedicalCertificatesReducerData => {
  switch (action.type) {
    case medicalCertificatesActionsTypes.GET_MEDICAL_CERTIFICATES:
      return {
        ...state,
        loadingMedicalCertificates: true,
      };

    case medicalCertificatesActionsTypes.GET_MEDICAL_CERTIFICATES_SUCCESS:
      return {
        ...state,
        loadingMedicalCertificates: false,
        medicalCertificates: action.payload,
      };

    case medicalCertificatesActionsTypes.GET_MEDICAL_CERTIFICATES_FAILURE:
      return {
        ...state,
        loadingMedicalCertificates: false,
        medicalCertificates: [],
      };

    case authenticationActionTypes.LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
};
